import { denormalisedResponseEntities, makeAlogoliaLocationData, onGetCloudnaryData } from '../../util/data';
import {
  algoliaCRUDApis,
  getCarrierAccount,
  updateCurrentCircleUserApi,
  validatingAddressWithShippo,
} from '../../util/api';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { UploadImage } from '../../util/cloudinary';
import { convertFileToMd5, mountFileToSend } from '../../util/circleHelper';
import {
  createDirectUpload,
  fetchCommunityMember,
  getCurrentUserCircleAuthParams,
  onGetCircleAuthToken,
} from '../CircleCommunityPage/CircleCommunityPage.duck';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ShippingInfoPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ShippingInfoPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ShippingInfoPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ShippingInfoPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ShippingInfoPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ShippingInfoPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ShippingInfoPage/UPDATE_PROFILE_ERROR';

export const VALIDATE_ADDRESS_REQUEST = 'app/ShippingInfoPage/VALIDATE_ADDRESS_REQUEST';
export const VALIDATE_ADDRESS_SUCCESS = 'app/ShippingInfoPage/VALIDATE_ADDRESS_SUCCESS';
export const VALIDATE_ADDRESS_ERROR = 'app/ShippingInfoPage/VALIDATE_ADDRESS_ERROR';

export const FETCH_CARRIER_ACCOUNT_REQUEST = 'app/ShippingInfoPage/FETCH_CARRIER_ACCOUNT_REQUEST';
export const FETCH_CARRIER_ACCOUNT_SUCCESS = 'app/ShippingInfoPage/FETCH_CARRIER_ACCOUNT_SUCCESS';
export const FETCH_CARRIER_ACCOUNT_ERROR = 'app/ShippingInfoPage/FETCH_CARRIER_ACCOUNT_ERROR';

export const FETCH_AUTHOR_SHIPPING_REQUEST = 'app/ShippingInfoPage/FETCH_AUTHOR_SHIPPING_REQUEST';
export const FETCH_AUTHOR_SHIPPING_SUCCESS = 'app/ShippingInfoPage/FETCH_AUTHOR_SHIPPING_SUCCESS';
export const FETCH_AUTHOR_SHIPPING_ERROR = 'app/ShippingInfoPage/FETCH_AUTHOR_SHIPPING_ERROR';

export const FETCH_AUTHOR_PICKUP_REQUEST = 'app/ShippingInfoPage/FETCH_AUTHOR_PICKUP_REQUEST';
export const FETCH_AUTHOR_PICKUP_SUCCESS = 'app/ShippingInfoPage/FETCH_AUTHOR_PICKUP_SUCCESS';
export const FETCH_AUTHOR_PICKUP_ERROR = 'app/ShippingInfoPage/FETCH_AUTHOR_PICKUP_ERROR';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,

  valideAddressInprogress: false,
  addressValidated: null,
  validateAddressError: null,

  fetchCarrierInprogress: false,
  carrierAccounts: [],
  fetchCarrierError: null,

  // pickup listings
  fetchAuthorPickupInprogress: false,
  authorPickupListings: [],
  fetchAuthorPickupError: null,
  // shipping listings
  fetchAuthorShippingInprogress: false,
  authorShippingListings: [],
  fetchAuthorShippingError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage, cloudProfileImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage, cloudProfileImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case VALIDATE_ADDRESS_REQUEST:
      return {
        ...state,
        valideAddressInprogress: true,
        validateAddressError: null,
      };
    case VALIDATE_ADDRESS_SUCCESS:
      return {
        ...state,
        addressValidated: payload,
        valideAddressInprogress: false,
      };
    case VALIDATE_ADDRESS_ERROR:
      return {
        ...state,
        image: null,
        valideAddressInprogress: false,
        validateAddressError: payload,
      };

    case FETCH_CARRIER_ACCOUNT_REQUEST:
      return {
        ...state,
        fetchCarrierInprogress: true,
        validateAddressError: null,
      };
    case FETCH_CARRIER_ACCOUNT_SUCCESS:
      return {
        ...state,
        carrierAccounts: payload,
        fetchCarrierInprogress: false,
      };
    case FETCH_CARRIER_ACCOUNT_ERROR:
      return {
        ...state,
        image: null,
        fetchCarrierInprogress: false,
        fetchCarrierError: payload,
      };

    case FETCH_AUTHOR_SHIPPING_REQUEST:
      return {
        ...state,
        fetchAuthorShippingInprogress: true,
        fetchAuthorShippingError: null,
        authorShippingListings: [],
        authorPickupListings: [],
      };
    case FETCH_AUTHOR_SHIPPING_SUCCESS:
      return {
        ...state,
        fetchAuthorShippingInprogress: false,
        authorShippingListings: payload,
        fetchAuthorShippingError: null,
      };
    case FETCH_AUTHOR_SHIPPING_ERROR:
      return {
        ...state,
        fetchAuthorShippingInprogress: false,
        fetchAuthorShippingError: true,
        authorShippingListings: []
      };

    case FETCH_AUTHOR_PICKUP_REQUEST:
      return {
        ...state,
        fetchAuthorPickupInprogress: true,
        authorPickupListings: [],
        fetchAuthorPickupError: null,
        authorShippingListings: []
      };
    case FETCH_AUTHOR_PICKUP_SUCCESS:
      return {
        ...state,
        fetchAuthorPickupInprogress: false,
        authorPickupListings: payload,
        fetchAuthorPickupError: null,
      };
    case FETCH_AUTHOR_PICKUP_ERROR:
      return {
        ...state,
        fetchAuthorPickupInprogress: false,
        authorPickupListings: [],
        fetchAuthorPickupError: true,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const validateAddressRequest = () => ({
  type: VALIDATE_ADDRESS_REQUEST,
});
export const validateAddressSuccess = result => ({
  type: VALIDATE_ADDRESS_SUCCESS,
  payload: result,
});
export const validateAddressError = error => ({
  type: VALIDATE_ADDRESS_ERROR,
  payload: error,
  error: true,
});

export const fetchCarrierRequest = () => ({
  type: FETCH_CARRIER_ACCOUNT_REQUEST,
});
export const fetchCarrierSuccess = result => ({
  type: FETCH_CARRIER_ACCOUNT_SUCCESS,
  payload: result,
});
export const fetchCarrierError = error => ({
  type: FETCH_CARRIER_ACCOUNT_ERROR,
  payload: error,
  error: true,
});


export const fetchAuthorShippingRequest = () => ({
  type: FETCH_AUTHOR_SHIPPING_REQUEST,
});
export const fetchAuthorShippingSuccess = result => ({
  type: FETCH_AUTHOR_SHIPPING_SUCCESS,
  payload: result,
});
export const fetchAuthorShippingError = error => ({
  type: FETCH_AUTHOR_SHIPPING_ERROR,
  payload: error,
  error: true,
});

export const fetchAuthorPickupRequest = () => ({
  type: FETCH_AUTHOR_PICKUP_REQUEST,
});
export const fetchAuthorPickupSuccess = result => ({
  type: FETCH_AUTHOR_PICKUP_SUCCESS,
  payload: result,
});
export const fetchAuthorPickupError = error => ({
  type: FETCH_AUTHOR_PICKUP_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

const updateUserCircleProfileImage = async (file, dispatch, getState) => {
  try {
    const md5 = await convertFileToMd5(file);
    const fileMetadata = mountFileToSend(file, md5);
    const response = await dispatch(createDirectUpload(fileMetadata, file));
    const { signed_id } = response || {};
    const data = { community_member: { avatar: signed_id } };

    const currentUser = getState()?.user?.currentUser;
    const { access_token } = await onGetCircleAuthToken(
      getCurrentUserCircleAuthParams(currentUser)
    );
    const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data });

    return profileResponse;
  } catch (error) {
    console.log('error', error);
  }
};

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const { id, file } = actionPayload;

    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(async resp => {
        const uploadedImage = resp.data.data;
        updateUserCircleProfileImage(file, dispatch, getState);
        // <<<<<<<< upload image in cloudnary >>>>>>>>>>>>>>>
        const cloudnaryResponse = await UploadImage({ id: uploadedImage.id.uuid, file, folder: 'profile-images' });
        dispatch(
          uploadImageSuccess({
            data: { id, uploadedImage, cloudProfileImage: onGetCloudnaryData(cloudnaryResponse) },
          })
        );
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

const updateCircleProfile = async (actionPayload, dispatch, getState) => {
  const currentUser = getState()?.user?.currentUser;
  const userId = currentUser?.id?.uuid;
  const { access_token, community_member_id } = await onGetCircleAuthToken(
    getCurrentUserCircleAuthParams(currentUser)
  );
  await dispatch(fetchCommunityMember(access_token, community_member_id));
  const { firstName, lastName, bio, displayName } = actionPayload;

  const { currentCommunityMember } = getState()?.CircleCommunityPage;
  const { profile_fields } = currentCommunityMember || {};
  const bioField = profile_fields?.visible?.find(item => item.key === 'bio');

  const bioParams = {
    textarea: bio || '',
    profile_field_id: bioField?.id,
    id: bioField?.community_member_profile_field?.id || null,
  };

  const data = {
    community_member: {
      ...(firstName && lastName && { name: displayName || `${firstName} ${lastName}` }),
      headline: userId,
      community_member_profile_fields_attributes: [...(bio ? [bioParams] : [])],
    },
  };

  const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data });
};

export const validateAddress = (params) => (dispatch, getState, sdk) => {
  dispatch(validateAddressRequest());

  return validatingAddressWithShippo({ ...params })
    .then((res) => {
      const validationResults = res?.validation_results;
      // Check if validation results exist
      if (!validationResults || Object.keys(validationResults).length === 0) {
        dispatch(validateAddressSuccess({ isValid: true }));
        return res;
      }
      // Check if the address is valid and has no error messages
      if (validationResults.is_valid && (!validationResults?.message || validationResults.messages.length === 0)) {
        dispatch(validateAddressSuccess({ isValid: true }));
      } else {
        dispatch(validateAddressSuccess({ isValid: false }));
      }
      return res;
    })
    .catch((error) => {
      dispatch(validateAddressError(storableError(error)));
      return null;
    });
};

// Helper: bulk update Algolia listings by seller_id with pickup/shipping details
const bulkUpdateSellerAlgoliaData = async ({ userId, locationData }) => {
  const indexName = process.env.REACT_APP_ALGOLIA_LISTING_INDEX;
  if (!indexName || !userId) return;

  const searchRes = await algoliaCRUDApis('getSearchData', {
    indexName,
    querySearch: '',
    filters: `seller_id:"${userId}"`,
    params: { hitsPerPage: 1000 },
  });
  const hits = searchRes?.data?.hits || [];
  if (!hits.length) return;
  const { pickShippingDetails, pickShippingOptions, _geoloc } = locationData || {};
  const updatePayload = hits.map(h => ({
    objectID: h.objectID,
    ...(Array.isArray(pickShippingDetails) && pickShippingDetails.length ? { pickShippingDetails } : {}),
    ...(pickShippingOptions ? { pickShippingOptions } : {}),
    ...(Array.isArray(_geoloc) && _geoloc.length ? { _geoloc } : {}),
  }));
  if (updatePayload.length) {
    await algoliaCRUDApis('updateSearchData', {
      indexName,
      data: updatePayload,
    });
  }
};

export const fetchCarrierAccounts = () => (dispatch, getState, sdk) => {
  dispatch(fetchCarrierRequest());
  return getCarrierAccount({})
    .then((res) => {
      dispatch(fetchCarrierSuccess(res));
      return res;
    })
    .catch(error => {
      dispatch(fetchCarrierError(storableError(error)))
    })
};

export const updateProfile = actionPayload => { 
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(async response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];
        // Update Data in alogila 
        const { publicData } = actionPayload;  
        const shippingAddress = publicData?.shippingAddress || {}; 
        const pickupAddress = publicData?.pickupAddress || {};
        if (shippingAddress?.selectedPlace || pickupAddress?.selectedPlace) {
          const userId = currentUser?.id.uuid;
          const locationData = makeAlogoliaLocationData({ userId, shippingAddress, pickupAddress });
          await bulkUpdateSellerAlgoliaData({ userId, locationData });
        }
        await updateCircleProfile(actionPayload, dispatch, getState);
        dispatch(updateProfileSuccess(response));
        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
        return currentUser;
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

export const fetchAuthorShippingListings = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchAuthorShippingRequest())
  return sdk.ownListings.query(params)
    .then(res => {
      dispatch(fetchAuthorShippingSuccess(res.data.data));
      return res
    })
    .catch(e => {
      dispatch(fetchAuthorShippingError(storableError(e)))
    });
};

export const fetchAuthorPicupListings = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchAuthorPickupRequest())
  return sdk.ownListings.query(params)
    .then(res => {
      dispatch(fetchAuthorPickupSuccess(res.data.data))
      return res;
    })
    .catch(e => {
      dispatch(fetchAuthorPickupError(storableError(e)))
      return e;
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const pageParams = {
    page: 1,
    perPage: 1,
  }
  const promises = [
    dispatch(fetchCarrierAccounts()),
    dispatch(fetchAuthorPicupListings({ pub_pickupEnabled: true, ...pageParams })),
    dispatch(fetchAuthorShippingListings({ pub_shippingEnabled: true, ...pageParams })),
  ];

  return Promise.all(promises)
    .then(response => response)
    .catch(e => {
      throw e;
    });
};
